import { mutationTypes } from '../../types';
import { uiComponents, uiStates } from '../../tools/viewState';

// viewState Handler watches mutations which have to result to a viewState change
// like poping and deleting Messages
export default store => {
	store.subscribe((mutation, state) => {
		if (mutation.type === mutationTypes.sendMessage) {
			if (!state.viewState[uiComponents.uiMessages] !== uiStates.hidden) {
				store.commit(mutationTypes.viewStateSetUiState, {
					id: uiComponents.uiMessages,
					uiState: uiStates.maximised,
				});
			}
		}
		if (mutation.type === mutationTypes.removeMessage) {
			if (state.messages.length === 0) {
				store.commit(mutationTypes.viewStateSetUiState, {
					id: uiComponents.uiMessages,
					uiState: uiStates.hidden,
				});
			}
		}
		if (mutation.type === mutationTypes.removeAllMessages) {
			store.commit(mutationTypes.viewStateSetUiState, {
				id: uiComponents.uiMessages,
				uiState: uiStates.hidden,
			});
		}
	});
};
